<template>

</template>
<script>
export default {
  name: "app-counter",
                 props: {
                   debug: {
                       type: Boolean,
                       default: !1
                   },
                     isActive: {
                         type: Boolean,
                         default: !1
                     },
                     from: {
                         type: Number,
                         default: 0
                     },
                     to: {
                         type: Number,
                         default: 100
                     },
                     delay: {
                         type: Number,
                         default: 50
                     },
                     increaseOffset: {
                         type: Number,
                         default: 2
                     }
                 },
                 data: function() {
                     return {
                         value: 0
                     }
                 },
                 watch: {
                     isActive: "onActiveChange"
                 },
                 mounted: function() {
                     this.value = this.from
                 },
                 methods:
                 {
                     onActiveChange: function()
                     {
                         this.isActive ? this.onIncrease() : this.onDecrease()
                     },
                     onIncrease: function()
                     {
                         var t = this;
                         this.value += this.increaseOffset,
                          this.value < this.to && setTimeout(function() {   t.onIncrease()   }, this.delay)
                     },
                     onDecrease: function()
                     {
                         this.value = this.from
                     }
                 }
 }

</script>
<style  scoped>
</style>



// WEBPACK FOOTER //
// src/components/app-counter/index.vue